import {createSlice} from '@reduxjs/toolkit';

function createInitialState() {
    return {
        documentShare: null,
        user: null,
        documents: [],
    };
}

export const clientFileSlice = createSlice({
    name: 'clientFile',
    initialState: createInitialState(),
    reducers: {
        succeedDocumentsFetch: (state, action) => {
            state.documents = action.payload.documents;
        },
        succeedDocumentShareFetch: (state, action) => {
            state.documentShare = action.payload;
        },
        succeedMetafieldsFetch: (state, action) => {
            state.metafields = action.payload;
        },
        succeedMetafieldsLabelsFetch: (state, action) => {
            state.metafieldsLabels = action.payload;
        },
        succeedUserFetch: (state, action) => {
            state.user = action.payload;
        },
        clearClientFile: (state, action) => {
            return createInitialState();
        }
    },
});

export const {succeedMetafieldsFetch, succeedDocumentsFetch, succeedDocumentShareFetch, succeedMetafieldsLabelsFetch, succeedUserFetch, clearClientFile} = clientFileSlice.actions;

export const selectDocuments = state => state.clientFile.documents;
export const selectDocumentShare = state => state.clientFile.documentShare;
export const selectMetafields = state => state.clientFile.metafields;
export const selectMetafieldsLabels = state => state.clientFile.metafieldsLabels;
export const selectUser = state => state.clientFile.user;

export default clientFileSlice.reducer;
